import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What could you do with an extra $1,000/month?",
  "description": "",
  "published": "2020-01-14T00:00:00.000Z",
  "redirect_from": ["/blog/what-could-you-do-with-an-extra-1000-month/swizec/9282"],
  "categories": "Opinions, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Imagine you're at a party, my friend. You're chatting with a friend of a friend and conversation turns to money.`}</p>
    <p><em parentName="p">{`"Oh yeah money is dumb, you don't need more than `}{`\\`}{`\\`}{`\\`}{`$75,000 to be happy anyway. Science said so"`}</em></p>
    <p>{`First of all, that's wrong. $75k is the global average for emotional well-being 👉 not being stressed the fuck out. The global average for "eh, maybe I'm good" is $95k. `}<a parentName="p" {...{
        "href": "https://www.nature.com/articles/s41562-017-0277-0"
      }}>{`[`}{`citation`}{`]`}</a></p>
    <p>{`That number goes as high as $320k in places like San Francisco 😳`}</p>
    <p>{`Second of all, someone says that and you can just imagine Scrooge McCapitalist laughing his way to the bank.`}</p>
    <p><img parentName="p" {...{
        "src": "/fab84b8df9ad77ff283476b2786744d4/media-26FPLMDDN5fJCir0A-giphy.gif",
        "alt": "scrooge_mcduck giphy"
      }}></img></p>
    <p>{`The greatest lie capitalists ever sold us is that talking about money is impolite. Second greatest is that we don't need more.`}</p>
    <p>{`Look around you, who are the people that say "money doesn't matter"?`}</p>
    <ol>
      <li parentName="ol">{`Upper middle class kids who never learned what $0 `}<em parentName="li">{`really`}</em>{` means`}</li>
      <li parentName="ol">{`Folks who feel stuck – `}<em parentName="li">{`"Oh I can't make more but that's okay it would't make me happy anyway"`}</em></li>
    </ol>
    <p>{`Bollocks.`}</p>
    <p><strong parentName="p">{`You are a software engineer. You can always make more.`}</strong></p>
    <p>{`But more money more problems, right?`}</p>
    <p>{`Oh boo-hoo, you need to spend $500 to save your $500,000 so it makes $50,000 in a year just sitting there? Cry me a river 🙄`}</p>
    <p>{`I don't know where that bullshit came from. More money more problems ... yeah maybe if you don't know how to use it.`}</p>
    <p>{`Money is a tool. A damn good tool.`}</p>
    <p>{`Think about it​. `}<strong parentName="p">{`What could an extra `}{`\\`}{`\\`}{`\\`}{`$1,000 per month do for you?`}</strong>{` Don't worry about how, imagine you have it already. What can it do?`}</p>
    <h2 {...{
      "id": "build-a-fuck-you-fund"
    }}>{`Build a fuck you fund`}</h2>
    <p>{`You could do what my favorite financial advisor Lucy Liu suggests 👉 build a fuck you fund.`}</p>
    <p><img parentName="p" {...{
        "src": "/6e272b0364cec0099647cb06bb003c87/iN3C60H.gif",
        "alt": null
      }}></img>{` `}<img parentName="p" {...{
        "src": "/b6dd7c11c392d039899092e34db65320/dLcAWJD.gif",
        "alt": null
      }}></img>{` `}<img parentName="p" {...{
        "src": "/d5e49ace5c0d7cca73abb7475c682067/kVwecsK.gif",
        "alt": null
      }}></img>{` `}<img parentName="p" {...{
        "src": "/6dec543456a32b1587fde24b3e0a7231/Ip9Z69v.gif",
        "alt": null
      }}></img></p>
    <p>{`A fuck you fund is the ultimate freedom. Even if it's small.`}</p>
    <p>{`The difference between living paycheck-to-paycheck and having just 1 month of savings can mean the difference between enduring a toxic job and quitting to find better.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You are always 1 day from fired, 1 week from hungry, 1 month from homeless`}</p>
    </blockquote>
    <p>{`Not with a fuck you fund you're not 😉`}</p>
    <h2 {...{
      "id": "buy-time"
    }}>{`Buy time`}</h2>
    <p>{`Money is time, right?`}</p>
    <p>{`It's true. Money `}<em parentName="p">{`is`}</em>{` time. And time is happiness.`}</p>
    <p>{`Imagine a chore you hate most. Picture it in your mind's eye. Really imagine it. What is the one thing you hate doing that feels like a total waste of time?`}</p>
    <p>{`Is it cleaning your house? Cooking dinner? Washing dishes? Vacuuming? Calling the doctor to make that appointment you've been putting off ever since your spouse found that weird mole on your back? Buying toilet paper?`}</p>
    <p>{`Someone else can do it.`}</p>
    <p>{`I have a friend who splurges on a daily meal service at his house. $10/day. No groceries, no shopping, no cooking, no cleaning.`}</p>
    <p>{`For $70/week, he saves hours of his time. Hours he can spend hanging out with friends instead.`}</p>
    <p>{`My girlfriend and I splurge on weekly cleaners who make our house look spotless. It's amazing. They even change the paper towels on Kiwi's play stand 😍`}</p>
    <p>{`2 frustrating hours of our life that we can spend at the farmer's market instead. Yes we're `}<em parentName="p">{`that`}</em>{` couple.`}</p>
    <p>{`I have an assistant. For $400/month she makes all those annoying calls that give me the heebie-jeebies. Last year she even dealt with the DMV for me.`}</p>
    <p>{`Best money I ever spent.`}</p>
    <p>{`What could `}<em parentName="p">{`you`}</em>{` do with an extra 2 hours in your week, my friend? Spend time with kids? Hang out with friends? Learn a new skill? Read that book you've been putting off? Think about it.`}</p>
    <h2 {...{
      "id": "buy-expertise"
    }}>{`Buy expertise`}</h2>
    <p>{`Beyond freedom, beyond time, money has another superpower 👉 solve problems.`}</p>
    <p>{`Your dishwasher breaks.`}</p>
    <p>{`Yeah you could fix it yourself. Find a video on YouTube, buy a bunch of tools, muck around for 2 hours, and figure it out. You're smart my friend, I believe in you.`}</p>
    <p>{`2 weeks later it breaks again. Maybe dishwashers just aren't your thing.`}</p>
    <p>{`With money, you can make a call, pay an expert, and hang out with your family while the expert deploys 10 years of dishwasher experience fixes it perfectly right away.`}</p>
    <p>{`Clean dishes for years. 🤘`}</p>
    <p>{`Heck, here's an even better example.`}</p>
    <p>{`Last year I got a job offer. Seemed like a cool opportunity, right in my wheel-house, big impact for the company.`}</p>
    <p>{`So I hired a salary negotiation expert.`}</p>
    <p>{`For $3000, I could sit back and relax. No worries about negotiation, no mental anguish over what to say, no pangs about pushing too far. `}<em parentName="p">{`"I got you, Swiz, I've done this hundreds of times. Don't worry"`}</em>{` he said.`}</p>
    <p>{`Worth every penny. But only because I could.`}</p>
    <p>{`Money 👉 freedom, time, and expertise.`}</p>
    <p>{`Think about it​. `}<strong parentName="p">{`What could you do with an extra `}{`\\`}{`\\`}{`\\`}{`$1,000/month?`}</strong>{` Hit reply`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`PS: did you know a whopping 63% of Americans couldn't cover a $500 emergency? `}<a parentName="p" {...{
        "href": "https://www.forbes.com/sites/maggiemcgrath/2016/01/06/63-of-americans-dont-have-enough-savings-to-cover-a-500-emergency/#650a3b634e0d"
      }}>{`Damn.`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      